const action = "FOUNDATION_BYOM_UPLOAD";
export const REQUEST  = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE  = action + '_FAILURE';
export const PROGRESS = action + '_PROGRESS';
export const CLEAR    = action + '_CLEAR';

// payload: { file }
export const fetchRequest  = (payload)  => ({ type: REQUEST,  payload });
export const fetchSuccess  = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure  = (error)    => ({ type: FAILURE,  payload: error });
export const uploadProgress = (percent) => ({ type: PROGRESS, payload: percent });
export const clearState    = ()         => ({ type: CLEAR });
